import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../Containers/Config/index.js';
import { GET_PERMISSIONS, GET_PERMISSIONS_SUCCESS, GET_PERMISSIONS_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getPermissions({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/permissions`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_PERMISSIONS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_PERMISSIONS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_PERMISSIONS_ERROR, payload: error });
  }
}

export function* watchPermissions() {
  yield takeEvery(GET_PERMISSIONS, getPermissions);
}

function* PermissionsSaga() {
  yield all([fork(watchPermissions)]);
}

export default PermissionsSaga;
